export const CONVERT_VALUE_FILTER: any = {
  'filter-news-games': '',
  'filter-news-upcoming-game': 'Upcoming game',
  'filter-news-new-game': 'New game',
  'filter-news-game-updates': 'Game update',
  'filter-news-events': 'Event',
  'filter-news-sales': 'Sale',
  'filter-news-downloads': 'Downloads',
  'filter-news-company': 'Company',
};
